import type { AppVersionPlatformSummary } from '../../services/connectConfig';

/**
 * Active devices on a build below `cutoff`, i.e. the ones a force-update
 * cutoff would block. Devices that never reported a build are counted
 * separately, since their build is unknown but older than reporting.
 */
export function activeDevicesBelow(
  summary: AppVersionPlatformSummary | undefined,
  cutoff: number,
): number {
  if (!summary || cutoff <= 0) return 0;
  return summary.builds
    .filter((build) => build.buildNumber < cutoff)
    .reduce((total, build) => total + build.active.devices, 0);
}
